import { Injectable, signal } from '@angular/core'
import { LoadingContexts } from '@shared/services/loading.interceptor'

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  #loading = signal<boolean>(false)
  loading = this.#loading.asReadonly()
  activeContext = signal<LoadingContexts[]>([])
  #activeRequests = 0

  on() {
    this.#activeRequests++
    this.#loading.set(true)
  }

  off() {
    this.#activeRequests--
    if (this.#activeRequests <= 0) {
      this.#activeRequests = 0
      this.#loading.set(false)
    }
  }

  setActiveContext(context: LoadingContexts) {
    this.activeContext.update(current => [...current, context])
  }

  unsetActiveContext(context: LoadingContexts) {
    this.activeContext.update(current => current.filter(c => c !== context))
  }

  isActiveContext(context: LoadingContexts) {
    return this.activeContext().find(c => c === context) !== undefined
  }
}
